import { types as t } from 'mobx-state-tree';

import { EmailTemplateStore } from 'models/templates';

export const TemplateStore = t
  .model('TemplateStore', {
    email: t.optional(EmailTemplateStore, {}),
  })
  .views((self) => ({
    get emailTemplates() {
      return self.email.items.filter(
        (template) =>
          template.templateType === 'rejection' ||
          template.templateType === 'applicant_new_application' ||
          template.templateType === 'message'
      );
    },
  }))
  .actions((self) => ({
    load() {
      self.loadEmail();
    },
    loadEmail() {
      return self.email.load();
    },
    addEmailTemplate(template) {
      self.email.addTemplate(template);
    },
  }));
